import React from 'react';
import PropTypes from 'prop-types';
import {getModelForResourceType} from 'resources/modelRegistry';

import {Text, Button, Anchor} from '@albert-io/atomic';

const ConfirmSchoolScreen = ({selectedSchool, confirmSchool, goBack}) => {
  return (
    <div className='confirm-school-screen u-display_flex u-flex-direction_column u-align-items_center'>
      <div className='u-mar-b_3 u-text-align_center u-line-height_150pc'>
        <Text size='regular' emphasis='highest' bold>
          Confirm your selection
        </Text>
      </div>
      <div className='u-mar-b_3 u-text-align_center u-line-height_150pc'>
        <Text size='regular' emphasis='lowest'>
          Selecting the wrong school may prevent you from accessing content.
        </Text>
      </div>
      <div className='confirm-school-screen__selected-school-information-container u-width_100pc u-mar-b_3 u-pad-tb_2 u-pad-lr_2'>
        <div className='u-mar-b_1 u-text-align_center u-line-height_140pc'>
          <Text bold size='l' emphasis='high'>
            {selectedSchool.getName()}
          </Text>
        </div>
        <div className='u-mar-b_1 u-text-align_center u-line-height_140pc'>
          <Text size='s' bold emphasis='high'>
            {selectedSchool.getIn(['district', 'name'], '')}
          </Text>
        </div>
        <div className='u-mar-b_1 u-text-align_center u-line-height_150pc'>
          <Text size='m' emphasis='high'>
            {selectedSchool.getFullAddress()}
          </Text>
        </div>
        <div className='u-text-align_center u-font-weight_bold u-line-height_150pc'>
          <Anchor as='button' underlined onClick={goBack} className='a-text--size-m'>
            Choose a different school
          </Anchor>
        </div>
      </div>
      <Button className='u-width_100pc u-line-height_140pc' onClick={confirmSchool}>
        Save
      </Button>
    </div>
  );
};

ConfirmSchoolScreen.propTypes = {
  selectedSchool: PropTypes.instanceOf(getModelForResourceType('school_v5')).isRequired,
  confirmSchool: PropTypes.func,
  goBack: PropTypes.func
};

export default ConfirmSchoolScreen;
